// eslint-disable-next-line import/no-extraneous-dependencies
import { KSIPreloadAPIConfig, KSIPreloadAPIRequestConfig } from '@sailor/ksi-tools-preload-request';
import { SLPreloadBizKFood } from '../Utils/index';

const SLLocation = Mach.requireModule('SLLocation');
const Login = Mach.requireModule('Login');

const kOrderStatusBundleName = 'mach_pro_sailor_c_order_status_golden';
const kOrderStatusBundleVersion = '0.1.49';

export const REQUEST_URL = {
  STATUS: 'v1/order/status',
  DETAIL: 'v1/order/detail'
};

export interface IActualLocation {
  latitude: number;
  longitude: number;
}

interface IRequestParams {
  bundleName: string;
  bundleVersion: string;
}

export interface IStatusRequestParams extends IRequestParams {
  channelId: string;
  actualLocation: IActualLocation;
  bundleName: string;
  bundleVersion: string;
  circleRequest: number;
}

export interface IDetailRequestParams extends IRequestParams {}

export class SLPreloadStatusRequestConfig extends KSIPreloadAPIRequestConfig {
  url(): string {
    return REQUEST_URL.STATUS;
  }

  body(schemeParams: any): object {
    return this.requestBody(schemeParams);
  }

  needFingerPrint(): boolean {
    return true;
  }

  requestBody = (schemeParams: any, requestParams?: IStatusRequestParams) => {
    const orderViewId = schemeParams?.orderViewId || '';
    const location = SLLocation?.getLocation();
    const {
      latitude,
      longitude,
      actualLatitude,
      actualLongitude
    } = location || {};
    const {
      actualLocation,
      circleRequest = 2,
      channelId = '1028',
      bundleName = kOrderStatusBundleName,
      bundleVersion = kOrderStatusBundleVersion,
    } = requestParams || {};

    const params = {
      orderViewId,
      latitude,
      longitude,
      channelId,
      bizCommon: {
        actualLatitude: actualLocation?.latitude || actualLatitude,
        actualLongitude: actualLocation?.longitude || actualLongitude,
        bundleName,
        bundleVersion,
      },
      circleRequest
    };
    return params;
  }

  handleResponseAvailable(response: any): boolean {
    return response && response.data && response.code === 0;
  }
}

const isHintPreload = () => {
  const WMABTest = Mach?.requireModule?.('SLABStrategy');
  const strategy = WMABTest?.getRealTimeStrategy?.({
    sceneKey: 'sailor_c_order_preload',
    groupKey: 'sailor_c_order_status_preload'
  });
  const hintList = ['A', 'B'].includes(strategy?.expKey);
  return hintList;
};

export class SLPreloadDetailRequestConfig extends KSIPreloadAPIRequestConfig {
  url(): string {
    return REQUEST_URL.DETAIL;
  }

  body(schemeParams: any): object {
    return this.requestBody(schemeParams);
  }

  requestBody = (schemeParams: any, requestParams?: IDetailRequestParams) => {
    const {
      bundleName = kOrderStatusBundleName,
      bundleVersion = kOrderStatusBundleVersion
    } = requestParams || {};
    const params = {
      orderViewId: schemeParams?.orderViewId || '',
      bundleName,
      bundleVersion,
    };
    return params;
  }

  handleResponseAvailable(response: any): boolean {
    return response && response.data && response.code === 0;
  }
}

export class SLPreloadOrderStatusAPIConfig extends KSIPreloadAPIConfig {
  statusRequestItem = new SLPreloadStatusRequestConfig();
  detailRequestItem = new SLPreloadDetailRequestConfig();
  bizline(): string {
    return SLPreloadBizKFood;
  }

  reqRuleVersion(): string {
    return `v${kOrderStatusBundleVersion}`;
  }

  bundleName(): string {
    return Mach.env.isAndroid ? 'mach_pro_sailor_c_order_status' : 'mach_pro_sailor_c_order_status_golden';
  }

  registry(): boolean {
    return (isHintPreload() && Login.isLogin()) ?? false;
  }

  timeoutCallbackDuration(): number {
    return 10000;
  }

  requestItems(): KSIPreloadAPIRequestConfig[] {
    return [
      this.statusRequestItem,
      this.detailRequestItem
    ];
  }
}
